// extracted by mini-css-extract-plugin
export default {"button":"ButtonClose_button__hdAxq","open":"ButtonClose_open__qJ2Pp"};